module.exports = __webpack_public_path__ + "img/res1-m.93a76f83.png";